import React from 'react';
import { Heading } from '../../components/typography';

const Setting = () => <h3>Instellingen</h3>;

export default Setting;
